import { colors } from 'constants/colorsBase';
import styled from 'styled-components';

export const ApproveHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${colors.lineColor};
  padding-bottom: 0.75rem;
  font-weight: 500;
`;
export const NameApproveHeader = styled.div`
  width: 16rem;
  padding-left: 0.75rem;
`;
export const ApplicationAmountHeader = styled.div`
  padding-left: 0.75rem;
`;
